(function(){
'use strict';
const NS='http://www.w3.org/2000/svg',CACHE=new Map(),urls=window.ArrelaserVectorFontUrls||{};
const translation={'ArrelaserDaydream':'Daydream','Daydream':'Daydream'};
const msg=e=>'No es pot vectoritzar la tipografia del disseny: '+e+'. Selecciona una font Arrelàser compatible o comunica la incidència abans de fer la comanda.';
async function load(name){
 name=translation[name]||name;
 const url=urls[name];
 if(!url)throw Error(msg(name));
 if(!window.opentype||typeof window.opentype.parse!=='function')throw Error('No s’ha carregat el motor de vectorització. Torna a carregar la pàgina.');
 if(!CACHE.has(name))CACHE.set(name,(async()=>{
  // No descarregar mai les URL CSS de fonts: Shopify pot servir-les com WOFF2.
  // El motor OpenType necessita els bytes originals TTF/OTF.
  const embedded=window.ArrelaserRawFonts?.[name];
  let buf;
  if(embedded){
    const data=atob(embedded),binary=new Uint8Array(data.length);
    for(let i=0;i<data.length;i++)binary[i]=data.charCodeAt(i);
    buf=binary.buffer;
  }else{
    const binaryUrl=window.ArrelaserRawBinaryUrls?.[name];
    if(!binaryUrl)throw Error('Falta el fitxer original de la font '+name+'. Recarrega la prova V59.');
    const response=await fetch(binaryUrl,{cache:'no-store'});
    if(!response.ok)throw Error('Font original no disponible: '+name+' ('+response.status+')');
    buf=await response.arrayBuffer();
  }
  const magic=String.fromCharCode(...new Uint8Array(buf.slice(0,4)));
  const header=new Uint8Array(buf,0,4);
  const isTtf=header[0]===0&&header[1]===1&&header[2]===0&&header[3]===0;
  if(!isTtf&&!['OTTO','true','typ1'].includes(magic)){
    // Els fonts TTF comencen per 00 01 00 00; els OpenType-CFF per OTTO.
    throw Error('La font '+name+' té un format no compatible ('+magic.replace(/[^A-Za-z0-9]/g,'?')+').');
  }
  try{return window.opentype.parse(buf)}
  catch(e){throw Error('No es pot llegir la font original '+name+': '+e.message)}
 })().catch(e=>{CACHE.delete(name);throw e}));
 return CACHE.get(name);
}
async function prepare(text,primary,weight){
 const fallback=await load('ArrelaserMontserrat');
 const main=await load(primary);
 const bold=Number(weight)>=600&&urls[primary+'Bold']?await load(primary+'Bold'):null;
 const out=[];
 for(const ch of Array.from(text)){
  let font=bold||main;
  if(ch.trim()&&font.charToGlyphIndex(ch)===0)font=fallback;
  if(ch.trim()&&font.charToGlyphIndex(ch)===0)throw Error(msg(primary+' · caràcter '+ch));
  out.push({ch,font,glyph:font.charToGlyph(ch)});
 }
 return out;
}
function oneLine(run,x,y,size,spacing,align,baseline,color,weight){
 let advances=run.map(v=>(v.glyph.advanceWidth||v.font.unitsPerEm*.5)*size/v.font.unitsPerEm);
 for(let i=1;i<run.length;i++)if(run[i].font===run[i-1].font){const k=run[i].font.getKerningValue(run[i-1].glyph,run[i].glyph);advances[i-1]+=k*size/run[i].font.unitsPerEm;}
 const total=advances.reduce((a,b)=>a+b,0)+Math.max(0,run.length-1)*spacing;
 let cursor=x-(align==='middle'?total/2:align==='end'?total:0),html=[],bounds=null;
 for(let i=0;i<run.length;i++){
  const v=run[i],path=v.glyph.getPath(cursor,y,size),d=path.toPathData(3);
  if(d){
   const bb=path.getBoundingBox();
   bounds=bounds?{y1:Math.min(bounds.y1,bb.y1),y2:Math.max(bounds.y2,bb.y2)}:{y1:bb.y1,y2:bb.y2};
   html.push('<path d="'+d+'" fill="'+color+'"'+(weight>=600&&!urls[v.font.names?.postScriptName?.en+'Bold']?'':'')+'/>');
  }
  cursor+=advances[i]+spacing;
 }
 const delta=baseline==='middle'&&bounds?y-(bounds.y1+bounds.y2)/2:0;
 return{html:html.join(''),delta};
}
function between(a,b,t){return a+(b-a)*t}
function parseQuad(d){
 const m=String(d||'').match(/M\s*([+-]?[\d.]+)[, ]+([+-]?[\d.]+)\s*Q\s*([+-]?[\d.]+)[, ]+([+-]?[\d.]+)\s*([+-]?[\d.]+)[, ]+([+-]?[\d.]+)/i);
 if(!m)throw Error('No es pot vectoritzar este text corbat: corba SVG desconeguda');
 return m.slice(1).map(Number);
}
function tableQuad(c){
 const [x0,y0,cx,cy,x1,y1]=c,out=[{d:0,t:0,x:x0,y:y0}],N=300;let len=0,px=x0,py=y0;
 for(let i=1;i<=N;i++){let t=i/N,u=1-t,x=u*u*x0+2*u*t*cx+t*t*x1,y=u*u*y0+2*u*t*cy+t*t*y1;len+=Math.hypot(x-px,y-py);out.push({d:len,t,x,y});px=x;py=y}
 return{out,len,c};
}
function sample(tab,dist){
 const v=Math.max(0,Math.min(tab.len,dist)),a=tab.out;let lo=0,hi=a.length-1;
 while(hi-lo>1){const mid=(lo+hi)>>1;if(a[mid].d<v)lo=mid;else hi=mid}
 const t=between(a[lo].t,a[hi].t,(v-a[lo].d)/(a[hi].d-a[lo].d||1));
 const [x0,y0,cx,cy,x1,y1]=tab.c,u=1-t,x=u*u*x0+2*u*t*cx+t*t*x1,y=u*u*y0+2*u*t*cy+t*t*y1,
 dx=2*u*(cx-x0)+2*t*(x1-cx),dy=2*u*(cy-y0)+2*t*(y1-cy);
 return{x,y,angle:Math.atan2(dy,dx)*180/Math.PI};
}
async function vectorize(xml){
 if(!window.DOMParser||!window.XMLSerializer)throw Error('Navegador no compatible amb la vectorització');
 const doc=new DOMParser().parseFromString(xml,'image/svg+xml');
 if(doc.querySelector('parsererror'))throw Error('SVG de fabricació invàlid');
 let count=0;
 for(const node of Array.from(doc.querySelectorAll('text'))){
  const family=node.getAttribute('font-family')||'';
  const size=Number(node.getAttribute('font-size')||5),weight=Number(node.getAttribute('font-weight')||400),anchor=node.getAttribute('text-anchor')||'start',color=node.getAttribute('fill')||'black',
   base=node.getAttribute('dominant-baseline')||'',letter=node.getAttribute('letter-spacing')||'0';
  if(!Number.isFinite(size)||size<=0)throw Error('Mida del text de gravat incorrecta');
  const space=parseFloat(letter)||0,spacing=letter.endsWith('em')?space*size:space;
  const g=doc.createElementNS(NS,'g');g.setAttribute('data-arrelaser-text-traçats','1');g.setAttribute('data-original-font',family);
  if(node.hasAttribute('transform'))g.setAttribute('transform',node.getAttribute('transform'));
  const curved=node.querySelector('textPath');
  if(curved){
   const href=curved.getAttribute('href')||curved.getAttribute('xlink:href')||'',id=href.replace(/^#/,'');
   const pathEl=Array.from(doc.querySelectorAll('path')).find(x=>x.getAttribute('id')===id);
   if(!pathEl)throw Error('Falta el camí del text corbat');
   const tab=tableQuad(parseQuad(pathEl.getAttribute('d'))),value=(curved.textContent||'').replace(/\s+/g,' '),run=await prepare(value,family,weight);
   const widths=run.map(v=>v.glyph.advanceWidth*size/v.font.unitsPerEm);
   let textWidth=widths.reduce((a,b)=>a+b,0)+Math.max(0,run.length-1)*spacing;
   if(textWidth>tab.len*1.015)throw Error('El text corbat no cap al recorregut. Reduïx-ne la mida.');
   let walk=tab.len/2-textWidth/2,paths='';
   for(let i=0;i<run.length;i++){
    const v=run[i],adv=widths[i],p=sample(tab,walk+adv/2),glyphPath=v.glyph.getPath(-adv/2,0,size),d=glyphPath.toPathData(3);
    if(d)paths+='<path fill="'+color+'" d="'+d+'" transform="translate('+p.x.toFixed(4)+' '+p.y.toFixed(4)+') rotate('+p.angle.toFixed(3)+')"/>';
    walk+=adv+spacing;
   }
   g.innerHTML=paths;
  }else if(node.querySelector('tspan')){
   let atY=Number(node.getAttribute('y')||0),parts=[];
   for(const child of Array.from(node.querySelectorAll('tspan'))){
    const yFixed=child.getAttribute('y');
    if(yFixed!==null)atY=Number(yFixed);
    atY+=Number(child.getAttribute('dy')||0);
    const atX=Number(child.getAttribute('x')||node.getAttribute('x')||0),run=await prepare(child.textContent||'',family,weight);
    parts.push(oneLine(run,atX,atY,size,spacing,anchor,'',color,weight).html);
   }
   g.innerHTML=parts.join('');
  }else{
   const value=node.textContent||'',x=Number(node.getAttribute('x')||0),y=Number(node.getAttribute('y')||0),run=await prepare(value,family,weight);
   const result=oneLine(run,x,y,size,spacing,anchor,base,color,weight);
   g.innerHTML=result.html;
   if(Math.abs(result.delta)>.00001)g.setAttribute('transform',(g.getAttribute('transform')||'')+' translate(0 '+result.delta.toFixed(5)+')');
  }
  if(weight>=600&&!/Bold|Black/.test(family)){g.setAttribute('stroke',color);g.setAttribute('stroke-width',String(size*.025));g.setAttribute('stroke-linejoin','round')}
  node.parentNode.replaceChild(g,node);count++;
 }
 if(doc.querySelector('text,textPath,tspan'))throw Error('No s’han convertit tots els textos a traçats');
 // Es poden enviar caixetes sense textos (només motius i encaixos).
 const output=new XMLSerializer().serializeToString(doc);
 if(/<text(?:\s|>)/i.test(output))throw Error('Encara queden textos SVG');
 return output;
}
window.ArrelaserVectorizer={vectorize};
})();

/* ARRELASER_WELD_V59_PATCH · soldadura de les siluetes de text per a LightBurn.
   Només afecta els grups de glifs generats pel motor; els contorns de la caixa
   i els motius originals es conserven sense modificar. */
(function(){
'use strict';
const NS_WELD='http://www.w3.org/2000/svg';
const oldVectorize=window.ArrelaserVectorizer&&window.ArrelaserVectorizer.vectorize;
if(typeof oldVectorize!=='function')throw Error('No està disponible el motor de traçats anterior');
const ownScript=document.currentScript||Array.from(document.scripts).find(s=>/arrelaser-svg-paths-v59-wof2fix\.js/.test(s.src));
const selfUrl=ownScript&&ownScript.src;
let paperPromise;
async function weldLibrary(){
 if(window.paper&&window.paper.PaperScope)return window.paper;
 if(!selfUrl)throw Error('No s’ha pogut localitzar la biblioteca de soldadura dins de Shopify.');
 if(!paperPromise)paperPromise=new Promise((resolve,reject)=>{
   const script=document.createElement('script');
   script.src=new URL('arrelaser-paper-v59.min.js',selfUrl).href;
   script.async=true;
   script.onload=()=>window.paper&&window.paper.PaperScope?resolve(window.paper):reject(Error('Biblioteca de soldadura incompatible'));
   script.onerror=()=>reject(Error('No s’ha pogut carregar la biblioteca de soldadura des de Shopify'));
   document.head.appendChild(script);
 }).catch(err=>{paperPromise=null;throw err});
 return paperPromise;
}
function weldOneGroup(group,scope,doc){
 const paths=Array.from(group.children).filter(el=>el.localName==='path');
 if(paths.length<2)return false;
 const fill=paths[0].getAttribute('fill')||'black';
 const shapes=paths.map((node)=>{
  const shape=scope.project.importSVG(node,{insert:false,applyMatrix:true});
  if(!shape||!['Path','CompoundPath'].includes(shape.className))throw Error('S’ha trobat un glif incompatible amb la soldadura');
  return shape;
 });
 const parts=[];
 for(const shape of shapes){
  let next=shape,joined=true;
  while(joined){
   joined=false;
   for(let i=0;i<parts.length;i++){
    if(!next.bounds.expand(0.003).intersects(parts[i].bounds))continue;
    const merged=next.unite(parts[i],{insert:false});
    if(!merged||!['Path','CompoundPath'].includes(merged.className)||!merged.pathData)throw Error('No es poden unir dos glifs superposats');
    next.remove();parts[i].remove();
    next=merged;
    parts.splice(i,1);
    joined=true;
    break;
   }
  }
  parts.push(next);
 }
 const out=[];
 for(const shape of parts){
  const d=shape.pathData;
  if(!d||/NaN|Infinity/.test(d))throw Error('La soldadura ha generat coordenades no vàlides');
  const p=doc.createElementNS(NS_WELD,'path');
  p.setAttribute('d',d);
  p.setAttribute('fill',fill);
  p.setAttribute('fill-rule','nonzero');
  p.setAttribute('data-arrelaser-soldat','1');
  out.push(p);
 }
 group.replaceChildren(...out);
 group.setAttribute('data-arrelaser-soldadura','v59');
 for(const s of parts)s.remove();
 return true;
}
window.ArrelaserVectorizer.vectorize=async function(svg){
 const raw=await oldVectorize(svg);
 const doc=new DOMParser().parseFromString(raw,'image/svg+xml');
 if(doc.querySelector('parsererror'))throw Error('SVG invàlid abans de soldar');
 const groups=Array.from(doc.querySelectorAll('g[data-arrelaser-text-traçats="1"]'));
 if(!groups.some(g=>g.querySelectorAll(':scope > path').length>1))return raw;
 try{
  const paper=await weldLibrary();
  const scope=new paper.PaperScope();
  scope.setup(new scope.Size(10,10));
  for(const group of groups)weldOneGroup(group,scope,doc);
  const output=new XMLSerializer().serializeToString(doc);
  if(doc.querySelector('text,textPath,tspan'))throw Error('La vectorització ha deixat text editable');
  return output;
 }catch(err){
  console.error('[Arrelàser V59 soldadura]',err);
  throw Error('No s’ha pogut soldar el text per a LightBurn: '+(err.message||err));
 }
};
window.ArrelaserVectorizer.weldVersion='V59';
})();
